import { useNavigate } from 'react-router-dom';
import { FiFileText, FiClipboard, FiShoppingBag, FiFolder, FiCpu, FiChevronRight } from 'react-icons/fi';
import Button from '../common/Button';
import SectionCard from './SectionCard';
import { ROUTES, IS_DEV } from '../../constants/constants';

const QUICK_ACTIONS = [
  { label: 'Draft Board Minutes', icon: <FiFileText size={14} />, route: ROUTES.MINUTES, tone: '#3a4a66' },
  { label: 'Generate Resolution', icon: <FiClipboard size={14} />, route: ROUTES.RESOLUTIONS, tone: '#8a6a1f' },
  ...(IS_DEV ? [{ label: 'Browse Marketplace', icon: <FiShoppingBag size={14} />, route: ROUTES.MARKETPLACE, tone: '#4a6b3f' }] : []),
  { label: 'Document Library', icon: <FiFolder size={14} />, route: ROUTES.DOC_LIBRARY, tone: '#145f5f' },
  // The AI Agent shipped to production (nav + routes un-gated); the quick
  // action follows. Marketplace above stays dev-only — no backend yet.
  { label: 'Ask Vee', icon: <FiCpu size={14} />, route: ROUTES.AGENT, tone: '#9a564a' },
];

/** QuickActions — the dashboard's shortcut list into the drafting surfaces. */
export default function QuickActions() {
  const navigate = useNavigate();
  return (
    <SectionCard icon="quick-actions" iconTone="#8a6a1f" title="Quick Actions">
      <div className="px-4 py-2.5 flex flex-col gap-2.5">
        {QUICK_ACTIONS.map((action) => (
          <Button
            key={action.label}
            variant="ghost"
            block
            leftIcon={
              <span
                className="inline-grid place-items-center w-[26px] h-[26px] rounded-[8px] border transition-all duration-200 group-hover:translate-x-0.5 group-hover:scale-105"
                style={{ background: `${action.tone}12`, color: action.tone, borderColor: `${action.tone}2b` }}
              >
                {action.icon}
              </span>
            }
            style={{ borderRadius: '12px', '--row-tone': action.tone }}
            className="group !justify-start !bg-transparent hover:!bg-[#faf7f2] !text-[#08111f] active:scale-[0.98] transition-all duration-200 ease-in-out relative !py-1.5 !px-2.5"
            onClick={() => navigate(action.route)}
          >
            <span className="ml-1 font-semibold text-[12px] transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-[var(--row-tone)]">
              {action.label}
            </span>
            <span className="absolute right-3.5 text-[#7a7060]/40 group-hover:translate-x-0.5 group-hover:text-[var(--row-tone)] transition-all duration-200">
              <FiChevronRight size={13} />
            </span>
          </Button>
        ))}
      </div>
    </SectionCard>
  );
}
